import { render, staticRenderFns } from "./IconArrowRight24.vue?vue&type=template&id=3a3644ab&"
import script from "./IconArrowRight24.vue?vue&type=script&lang=js&"
export * from "./IconArrowRight24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports